import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { ReactComponent as GreaterThan } from 'assets/icons/greater-than.svg';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-left.svg';

import React from 'react';
import { Tab } from 'components/tab';
import { useNavigate, useParams } from 'react-router-dom';
import BasicDetails from './partials/basic-details';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import useDashboardContext from 'contexts/dashboard.context';

const SingleStoreDetails = () => {
  const { storeSubRoute } = useParams();
  const navigate = useNavigate();
  const { activeStore, setRefreshStore, refreshStore } = useDashboardContext();
  const tabs = [
    {
      label: 'Basic details',
      key: 'basic-details',
      content: <BasicDetails id={storeSubRoute ?? ''} />
    }
    // To be reimplemented once roles and permissions are ready
    // {
    //   label: 'Roles & Permissions',
    //   key: 'roles-permissions',
    //   content: <RolesPermissions />
    // }
  ];
  const defaultTab = tabs?.find((tab) => tab?.key === storeSubRoute) ?? tabs[0];
  const changeStoreStatus = async () => {
    if (!activeStore?.id) return;
    try {
      await apiService.put(`stores/${activeStore?.id}/status`, {
        data: { active: !activeStore?.active }
      });
      toast(<ToastMessage type='success' message={'Store status is updated'} />);
      setRefreshStore(!refreshStore);
      navigate(MAIN_STORE_ROUTE_KEYS.GENERAL_STORE_DASHBOARD);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    }
  };
  return (
    <main className='mx-5'>
      <section>
        <ArrowBackIcon
          onClick={() => navigate(MAIN_STORE_ROUTE_KEYS.GENERAL_STORE_DASHBOARD)}
          className='text-gray-6'
        />
        <div className='text-sm font-medium flex items-center gap-2 my-4'>
          <button className='text-gray-4 ' onClick={() => navigate('/general-store')}>
            General store dashboard
          </button>
          <GreaterThan />
          <span>{activeStore?.name}</span>
        </div>
        <div className='flex justify-between items-center '>
          <div>
            <h1 className='text-2xl font-bold'>{activeStore?.name}</h1>
            <p className='text-gray-9 text-sm'>Manage and track the quantity of items in stock</p>
          </div>
          <div>
            <Button
              onClick={changeStoreStatus}
              color='primary'
              variant='block'
              size='small'
              className='px-4'>
              {activeStore?.active ? 'Deactivate Store' : 'Activate Store'}
            </Button>
          </div>
        </div>
      </section>
      <section className='mt-10'>
        <Tab tabs={tabs ?? []} defaultSelectedTab={defaultTab} />
      </section>
    </main>
  );
};

export default SingleStoreDetails;
